// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bhk_a bhy_h","Menu__offsetParent":"bhk_b bhy_bj","Menu__trigger--shadowed":"bhk_c"};